module.exports = __webpack_public_path__ + "img/樊永刚.d7c24779.jpg";